import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyAjNYMZK8mWPzKVR5fgba7k0K5f0I9nq2Q",
  authDomain: "shaundjuacademy.firebaseapp.com",
  projectId: "shaundjuacademy",
  storageBucket: "shaundjuacademy.firebasestorage.app",
  messagingSenderId: "997586301638",
  appId: "1:997586301638:web:3cdb72cf04cf9dd1a61dc7",
  measurementId: "G-5RKEYS68FE"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

export default app; 